import { assertOkOrThrow } from './client';

/**
 * Sibling of apiFetch that returns the raw Response so the caller can read text + headers.
 * Same 401-redirect contract; non-2xx throws ApiError carrying parsed/text body.
 */
export async function responseFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers: Record<string, string> = {
    Accept: '*/*',
    ...((init.headers as Record<string, string>) ?? {}),
  };
  const response = await fetch(path, { ...init, credentials: 'include', headers });
  await assertOkOrThrow(response);
  return response;
}
